import { useEffect } from 'react'
import { toast } from 'sonner'
import { ToasterContent } from '@/components/sv/toaster-content'
import { SUBSCRIPTION_CANCELLED_KEY } from '@/config/session-storage'

export const SubscriptionCancelledToast = () => {
  useEffect(() => {
    const isSubscriptionCancelled = Boolean(
      sessionStorage.getItem(SUBSCRIPTION_CANCELLED_KEY)
    )

    if (!isSubscriptionCancelled) {
      return
    }

    sessionStorage.removeItem(SUBSCRIPTION_CANCELLED_KEY)
    toast(
      <ToasterContent variant="success">
        Sevalla subscription cancelled.
      </ToasterContent>,
      { position: 'top-right' }
    )
  }, [])

  return null
}
